
import {
    Form, Row, Col, Input, Card, AspectRatio, Button,
    ProTableOt, useProTableOt, setParamsFilter,
    Typography
} from '../../ui/ot'
import { useEffect, useState, useRef } from "react"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useBib } from '../../koha/controllers/bib_controller';
import BibMarc21InfoModal from '../../koha/views/bib_marc21_info_modal';
import { useSearchParams, useNavigate } from "react-router-dom";

const CollectionSearch = ({
    keyPrefix = 'library.online_public_catalog_query_construction.collection_search',
    onSelectChange = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    extraParams,
    customColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    propsRowKey = "task_id",
    showDefaultColumn = true,
    showDefaultFormItems = [],
    propsModalOpen: modalOpenExternal,
    propsSetModalOpen: setModalOpenExternal,
    propsInitialValues,
    propsForm,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const biblionumber = searchParams.get("biblionumber")
    const actionRef = useRef(null);
    const [tableSearchParams, setTableSearchParams] = useState({
        biblionumber: biblionumber
    });
    const columns = [
        {
            title: '#',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: t(`Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t(`Current library`),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t(`Home library`),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t(`call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t(`Status`),
            dataIndex: 'issue_cancheckout',
            key: 'issue_cancheckout',
            render: (text, record, index) => {
                if (record?.issue_cancheckout > 0) {
                    return <>
                        {t(`CanCheckout`)}
                    </>
                } else {
                    return <>
                        {t(`CantCheckout`)}
                    </>
                }
            }
        },
        {
            title: t(`Date last borrowed`),
            dataIndex: 'item_datelastborrowed',
            key: 'item_datelastborrowed',
        },
        {
            title: t(`Copy number`),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
        // {
        //     title: t('action'),
        //     dataIndex: 'action',
        //     key: 'action',
        //     render: (_, record) => {
        //         return (<>
        //             {extraActionRender(record)}
        //         </>)
        //     }
        // },
    ];
    const bibItemController = useCRUDController({
        apiRoute: "/koha/item",
    })
    const bibController = useCRUDController({
        apiRoute: "/koha/bib",
    })
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    const {
        BibData,
        getBibData,
        getBibInfoFormat
    } = useBib({
        onFinish: () => { },
        onBefore: () => { }
    })
    useEffect(() => {
        checkAll();
        getBibData({
            biblionumber: biblionumber,
            marcdata: "json"
        })
        bibController.getData({
            biblionumber: biblionumber
        })
    }, [])
    return (<Row gutter={[32, 32]}>
        <Col span={24}>
        </Col>
        <Col span={24}>
            <Row>
                {
                    bibController.ResponseData.map((value) => {
                        return (
                            <Col span={24}>
                                <Row gutter={[32, 32]} justify="center">
                                    <Col span={23}>
                                        <Card  >
                                            <Row gutter={[16, 16]}>
                                                <Col xxl={6} xl={6} lg={6} md={8} sm={24} xs={24}   >
                                                    <Row justify={"center"}>
                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={8} xs={12} >
                                                            <AspectRatio ratio={3 / 4}>
                                                                <img
                                                                    src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                                                        value?.bibitem_isbn} className=" h-full w-full rounded-md object-cover" />
                                                            </AspectRatio>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xxl={18} xl={18} lg={18} md={16} sm={24} xs={24}>
                                                    <Row gutter={[16, 16]}>
                                                        {
                                                            getBibInfoFormat().map((val) => {
                                                                if (val?.language_name === "bib_title") {
                                                                    return (
                                                                        <Typography.Title level={3}>
                                                                            {val?.valueKeys.map((keysValue) => value?.[keysValue])}
                                                                        </Typography.Title>
                                                                    )
                                                                }
                                                                else if (val?.language_name === "Language") {
                                                                    return (
                                                                        <Col span={24}>
                                                                            <Typography.P>{t(`${val?.language_name}`)}: {val?.valueKeys.map((keysValue) => value?.[keysValue]?.['Language'])} </Typography.P>
                                                                        </Col>
                                                                    )
                                                                }
                                                                else {
                                                                    return <Col span={24}>
                                                                        <Typography.P>{t(`${val?.language_name}`)}:
                                                                            {val?.valueKeys.map((keysValue) => {
                                                                                if (val?.isJoin) {
                                                                                    return value?.[keysValue]?.join('、')
                                                                                }
                                                                                else {
                                                                                    return value?.[keysValue]
                                                                                }
                                                                            })}
                                                                        </Typography.P>
                                                                    </Col>
                                                                }

                                                            })
                                                        }
                                                        <Col span={24}>
                                                            <BibMarc21InfoModal
                                                                bib_biblionumber={biblionumber}
                                                                bib_title={value?.bib_title}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row>
                                                        <Col>
                                                            <Typography.Title level={4}>
                                                                館藏資訊
                                                            </Typography.Title>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <ProTableOt
                                                        searchParams={tableSearchParams}
                                                        showSearch={false}
                                                        reloadButton={false}
                                                        manageColumnsButton={false}
                                                        rowKey={"item_itemnumber"}
                                                        actionRef={actionRef}
                                                        columns={columns}
                                                        check={check}
                                                        setCheck={setCheck}
                                                        request={async (params = {}, sort, filter) => {
                                                            // setAxiosMethod("get")
                                                            let newParams = {};
                                                            let order = setOrders(sort);
                                                            newParams = {
                                                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                                                ...newParams,
                                                                order,
                                                                size: params.pageSize,
                                                                cur_page: params.current,
                                                                // custom_filter_value: params.keyword ?? "",
                                                                // custom_filter_key: custom_filter_key,
                                                                ...tableSearchParams
                                                            };
                                                            newParams = setParamsFilter({
                                                                ...newParams,
                                                            });
                                                            return bibItemController.getData({
                                                                ...newParams,
                                                            });
                                                        }}
                                                        rowSelection={false}
                                                        manage_columns={true}
                                                    />
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                </Row>
                            </Col>
                        )
                    })
                }
                <Col span={24}>

                </Col>
            </Row>
        </Col>
    </Row>)
}
export default CollectionSearch